export default "__VITE_ASSET__DOUOv6v___"